export const hasNotif = (channelList) => {
  return (channelList || []).some(
    (item) => (item.character.id < 6 || item.character.id > 11) && item.unreadTotal > 0
  )
}
